import React from 'react';
import _ from 'lodash';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import Select from 'react-select';
import { push } from 'react-router-redux';
import getCourts from '../actions/courtsActions';
import { setPendingBookingCourtEventId } from '../actions/pendingBookingActions';
import { setCourtsFilters } from '../actions/filterActions';
import { courtsFiltersModes } from '../utils/constants';
import Button from '../components/Button';
import i18n from '../utils/i18n';
import routeConstants from '../utils/routeConstants';

import './styles/CourtsFiltersContainer.scss';

const MAX_FILTERS_FOR_PART_VIEW = 1;

class CourtsFiltersContainer extends React.Component {
  constructor(props) {
    super(props);
    this.routeToCourtsFiltersScreen = this.routeToCourtsFiltersScreen.bind(
      this
    );
  }

  onCourtFilterChange(filterIndex, newValue) {
    const { courtsFilters } = this.props;
    const newFilters = _.clone(courtsFilters);
    if(newValue !== null) {
      newFilters[filterIndex].selected = [newValue];
    } else {
      newFilters[filterIndex].selected = [];
    }

    this.props.setCourtsFilters(newFilters);
    if (this.props.updateOnSelect) {
      this.props.getCourts(newFilters);
    }
  }

  routeToCourtsFiltersScreen() {
    this.props.dispatch(push(routeConstants.COURTS_FILTERS_ROUTE));
  }

  renderCourtsFilters() {
    let courtsFiltersCopy = _.clone(this.props.courtsFilters);
    const isPartMode = this.props.courtsFiltersMode === courtsFiltersModes.PART;
    const filtersNumberOverMaxFiltersNumber =
      courtsFiltersCopy.length > MAX_FILTERS_FOR_PART_VIEW;
    const needToCutFilters = isPartMode && filtersNumberOverMaxFiltersNumber;

    let renderedElements = [];
    if (needToCutFilters) {
      courtsFiltersCopy = courtsFiltersCopy.slice(0, MAX_FILTERS_FOR_PART_VIEW);
    }
    renderedElements = courtsFiltersCopy.map((filter, filterIndex) => (
      <Select
        key={ filter.name }
        options={ filter.values.map((value, valueIndex) => ({
          value: valueIndex,
          label: `${value.value}`,
          className: value.sub === 1 ? 'sub' : ''
        })) }
        onBlurResetsInput={ false }
        onSelectResetsInput={ false }
        simpleValue
        value={ filter.selected[0] }
        onChange={ newValue => this.onCourtFilterChange(filterIndex, newValue) }
        className="select-box"
        placeholder={ filter.name }
      />
    ));

    if (needToCutFilters) {
      renderedElements.push(
        <Button
          key="button"
          text={ i18n.t('courtsScreen.MORE_FILTERS') }
          onClick={ this.routeToCourtsFiltersScreen }
          buttonClass="filters-button"
        />
      );
    }

    return renderedElements;
  }

  render() {
    return <div className="courts-filters">{this.renderCourtsFilters()}</div>;
  }
}

CourtsFiltersContainer.propTypes = {
  courtsFilters: PropTypes.arrayOf(PropTypes.shape({})),
  setCourtsFilters: PropTypes.func.isRequired,
  getCourts: PropTypes.func.isRequired,
  courtsFiltersMode: PropTypes.oneOf([
    courtsFiltersModes.FULL,
    courtsFiltersModes.PART
  ]),
  dispatch: PropTypes.func.isRequired,
  updateOnSelect: PropTypes.bool
};

CourtsFiltersContainer.defaultProps = {
  courtsFilters: [],
  courtsFiltersMode: courtsFiltersModes.FULL,
  updateOnSelect: true
};

const mapStateToProps = state => ({
  courtsFilters: state.filter.courtsFilters
});

const mapDispatchToProps = dispatch => ({
  dispatch,
  getCourts: filters => dispatch(getCourts(filters)),
  setPendingBookingCourtEventId: id =>
    dispatch(setPendingBookingCourtEventId(id)),
  setCourtsFilters: filters => dispatch(setCourtsFilters(filters))
});

export default connect(mapStateToProps, mapDispatchToProps)(
  CourtsFiltersContainer
);



// WEBPACK FOOTER //
// ./src/containers/CourtsFiltersContainer.js